import { render, staticRenderFns } from "./AddictiveStuffChronicDiseases.vue?vue&type=template&id=93aab332&"
import script from "./AddictiveStuffChronicDiseases.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffChronicDiseases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports